<template>
    <div>
        <h3 class="columnTit mt10"><span>拍卖资讯</span></h3>
        <div class="newsList" v-if="newsList">
            <template v-for="(item,i) in newsList">
                <dl class="fix" :key="i" v-if="i<25">
                    <dt v-if="item.pic.length">
                        <a :href="item.link!=''?item.link:item.wap_url" target="_blank">
                            <div class="imgBox"  @click="contentClick(item)">
                                <div v-if="item.tag_text" class="falg">{{item.tag_text}}</div>
                                <el-image
                                    style="width: 100%; height: 100%;"
                                    :src="item.pic[0]" fit="contain">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="el-image__error">
                                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                    </div>
                                </el-image>
                            </div>
                        </a>
                    </dt>
                    <dd>
                        <div class="newsInfo">
                            <h4  @click="contentClick(item)"><a :href="item.link!=''?item.link:item.wap_url" target="_blank">{{item.title}}</a></h4>
                            <p class="newsInfo">{{item.summary}}</p>
                        </div>
                        <div class="newsTime">
                            <div class="time">{{item.published_text}}</div>
                            <div class="view" v-if="item.view_num > 0">{{item.view_num}}</div>
                        </div>
                    </dd>
                </dl>
            </template>
        </div>
    </div>
</template>

<script>
import {getNews} from "@/api/index";
// 神策埋点
import { contentClick } from '@/utils/buriedPoint.js'
export default {
    name: "IndexNews",
    data(){
        return{
            newsList:[]
        }
    },
    mounted() {
        this.getNews()
    },
    methods:{
        getNews(){
            getNews().then((res) => {
                this.newsList = res.data.list
            });
        },
        contentClick(item) {
            contentClick(item.resource_id,item.title,item.tag_text,'拍卖首页')
        }
    }
}
</script>

<style scoped lang="scss">
/*拍卖资讯*/
.newsList{
    .imgBox{
        position:relative;
         .falg{position: absolute;right:0;top:10px;height:18px;
                 background: #18BD6F;
                 padding: 0 8px;
           color: #fff;
           text-align: center;
           font-size: 14px;
           line-height:18px;
            border-top-left-radius: 20px;
             border-bottom-left-radius:  20px;
            }
    }
    dl{margin-bottom: 20px;display:flex;justify-content: space-between;}
    dl:last-child{margin-bottom: 0;width:780px;}
    dt{width:246px;height:164px;border-radius: 4px;overflow: hidden;}
    dd{height:164px;position: relative;overflow: hidden;width:100%;
        .newsInfo{
            h4{font-size: 18px;line-height: 26px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#262626;width:100%;overflow: hidden;}
            p{line-height: 22px;font-size: 14px;color:#595959;max-height: 66px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow: ellipsis;margin-top: 20px;}
        }
        .newsTime{position: absolute;bottom:10px;left:0;width:100%;display:flex;justify-content: space-between;
            .flag{font-size: 0;
                span{display:inline-block;padding:0 3px;border:1px solid #D9D9D9;line-height: 20px;font-size: 12px;color:#8C8C8C;margin-right: 10px;border-radius: 4px;}
            }
            .time{font-size: 14px;color:#8C8C8C;line-height: 22px;}
            .view{font-size: 14px;color:#8C8C8C;background:url("../../assets/imgs/icon_show.png") no-repeat center left;padding-left: 20px;line-height: 24px;}
        }
    }
    dt+dd{width:514px;}
    a:hover{
        dd{
            .newsInfo{
                h4,p{color:#329D15;}
            }
            .newsTime{
                .time{color:#329D15;}
            }
        }
    }
}
</style>